export const ru = {
    'copy-message': 'Скопировано'
};
